import {
	AnyRoute,
	createRootRoute,
	createRoute,
	createRouter,
} from '@tanstack/react-router';

import config from '@/config';
import { basepath } from '@/constants';

import { NotFound, RootRouteComponent } from '@/views/RootRoute';

import { useAuth } from '@/views/home/auth/Authentication.hooks';
import { IssueView } from '@/views/issue/Issue';
import Drafts from '@/views/drafts/Drafts';
import Preview from '@/views/preview/Preview';
import Favorite from '@/views/favorite/Favorite';

import { homeSearchSchema, HomeView } from './home/Home';

import { CollectionView } from './collection/Collection';
import { issueSearchSchema } from '@/views/issue/Issue.hooks';

/* Routes declaration */

const rootRoute = createRootRoute({
	component: RootRouteComponent,
});

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/',
	validateSearch: homeSearchSchema,
	component: Home,
});

const issuesRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: IssueView,
	path: 'issues',
});

const previewRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Preview,
	path: 'preview/$id',
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: AuthIssue,
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

const collectionRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: AuthCollection,
	path: 'collections/$id',
});

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	component: AuthIssue,
	validateSearch: issueSearchSchema,
	path: '$articleId',
});

const draftsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Drafts,
	path: 'drafts',
});

const favoriteRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Favorite,
	path: 'favorite/$id',
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [
	indexRoute,
	issuesRoute,
	previewRoute,
	issueRoute,
	issueArticleRoute,
	collectionRoute,
];

if (config?.app?.admin) {
	routes.push(draftsRoute);
}

if (config?.app?.favorite) {
	routes.push(favoriteRoute);
}

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,
});

function Home() {
	useAuth({ redirect: false });
	return (
		<>
			<HomeView />
		</>
	);
}

function AuthIssue() {
	useAuth({ redirect: true });
	return (
		<>
			<IssueView />
		</>
	);
}

function AuthCollection() {
	useAuth({ redirect: true });
	return (
		<>
			<CollectionView />
		</>
	);
}
